export const aboutInfo = {
  brandName: '51吃瓜网',
  brandIntroduction: `51吃瓜网成立于2023年，是国内领先的网红资讯与娱乐内容平台。我们致力于为千万粉丝提供最新、最全、最有趣的网红动态、人物专题和娱乐八卦内容。

在信息爆炸的时代，51吃瓜网坚持"真实、有趣、有价值"的内容理念。我们的编辑团队由资深娱乐记者和内容创作者组成，每天7×24小时追踪网红圈的最新动态，为用户提供深度、专业的报道和分析。

经过三年多的发展，51吃瓜网已积累了超过500万的忠实用户，月均活跃用户突破200万。我们的内容覆盖了包括台北娜娜、莫里秀、玩偶姐姐在内的1000+热门网红人物，形成了人物合集、系列专题、网红动态、热门八卦等多个特色内容板块。

展望未来，51吃瓜网将继续深耕网红资讯领域，以更优质的内容、更丰富的呈现形式和更好的用户体验，服务每一位关注网红文化的用户。`,
  reputation: `用户口碑是51吃瓜网最宝贵的财富。自成立以来，我们始终以用户为中心，不断优化内容质量和用户体验。

"51吃瓜网是我每天必刷的网站，内容更新及时，文章质量很高"——来自北京的用户张女士

"作为一个追星女孩，51吃瓜网帮我省去了在各个平台找信息的时间，一站式了解所有网红动态"——来自上海的用户李小姐

"最喜欢人物合集栏目，可以系统地了解一个网红的完整故事，而不是零散的八卦"——来自广州的用户王先生

在各大应用商店和社交平台上，51吃瓜网保持了4.8分以上的高评分。我们珍视每一位用户的反馈，并将持续努力，不辜负大家的信任和期待。`,
  contact: {
    email: 'contact@51chigua.com',
    wechat: 'chigua51_official',
    weibo: '@51吃瓜网官方',
    phone: '400-888-5151',
    address: '北京市朝阳区建国路88号SOHO现代城A座1508室',
    workingHours: '周一至周五 9:00 - 18:00',
  },
  stats: {
    totalUsers: '500万+',
    monthlyActive: '200万+',
    totalArticles: '10万+',
    coveredInfluencers: '1000+',
  },
};